import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

function Footer({ onOpenCookiePreferencesModal, hasAcceptedTrackingCookies, setFooterHeight, onTopicClick }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const footerRef = useRef(null);

    const COLLAPSED_FOOTER_HEIGHT = 60;
    const EXPANDED_FOOTER_HEIGHT = 150;

    const footerDynamicStyles = {
        maxHeight: isExpanded ? `${EXPANDED_FOOTER_HEIGHT}px` : `${COLLAPSED_FOOTER_HEIGHT}px`,
        zIndex: 9999,
    };

    const handleToggleExpand = () => {
        setIsExpanded(prev => !prev);
    };

    const handleResetConsent = () => {
        onOpenCookiePreferencesModal();
    };

    // Questo useEffect invia l'altezza del footer al genitore (MyApp)
    useEffect(() => {
        if (footerRef.current && setFooterHeight) { // Assicurati che setFooterHeight sia definito
            const currentHeight = footerRef.current.clientHeight;
            // console.log("Footer useEffect: Altezza corrente del footer:", currentHeight); // DEBUG
            setFooterHeight(currentHeight); // Invia l'altezza al genitore
        }
    }, [isExpanded, setFooterHeight]); // Dipende da isExpanded (per ri-calcolare al toggle) e setFooterHeight

    // Determina se il balloon deve mostrare la classe 'show-balloon'
    const showPrivacyBalloon = !isExpanded && isHovered && hasAcceptedTrackingCookies;

    return (
        <footer
            ref={footerRef}
            style={footerDynamicStyles}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="footer-content-wrapper">
                {/* Left Block: Cookie Preferences Button and Links */}
                <div className="footer-left-block">
                    <button
                        onClick={handleResetConsent}
                        className="cookie-preferences-button"
                    >
                        Manage Cookie Preferences
                    </button>
                    {isExpanded && (
                        <div className="links-wrapper">
                            {/* MODIFICATO: Usa onClick e onTopicClick per la navigazione interna */}
                            <a 
                                className="footer-link" 
                                onClick={() => onTopicClick('privacy-policy')}
                                style={{cursor: 'pointer'}} // Aggiungi questo per indicare che è cliccabile
                            >
                                Privacy Policy
                            </a>
                            {/* MODIFICATO: Usa onClick e onTopicClick per la navigazione interna */}
                            <a 
                                className="footer-link" 
                                onClick={() => onTopicClick('cookie-policy')}
                                style={{cursor: 'pointer'}} // Aggiungi questo per indicare che è cliccabile
                            >
                                Cookie Policy
                            </a>
                        </div>
                    )}
                </div>

                {/* Center: Toggle Button */}
                <button className="footer-toggle-button" onClick={handleToggleExpand}>
                    <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronUp} />
                </button>

                {/* Right Block: Copyright Text */}
                <div className="footer-right-block">
                    <p className="copyright-text">
                        &copy; {new Date().getFullYear()} ZapDesign. Tutti i diritti riservati.
                    </p>
                </div>
            </div>

            {/* Balloon for privacy reminder - ALWAYS RENDERED, visibility controlled by CSS class */}
            <div className={`privacy-balloon ${showPrivacyBalloon ? 'show-balloon' : ''}`}>
                Manage your privacy preferences here!
            </div>
        </footer>
    );
}

export default Footer;
